module.exports = __webpack_public_path__ + "img/inharmony.c7718d88.png";